import { RenderElementProps } from "slate-react";

import {
  EditorElement,
  EditorElementType,
} from "@smart/itops-serialisation-basic";

export type ElementRendererProps<
  T extends EditorElementType = EditorElementType,
> = RenderElementProps & {
  element: EditorElement<T>;
  readOnly?: boolean;
  isLinkEnabled?: boolean;
};

export const Paragraph = ({
  attributes,
  children,
}: ElementRendererProps<"paragraph">) => (
  <span className="block m-0" {...attributes}>
    {children}
  </span>
);
